<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="shopLibrary">
			<div class="multi-table">
				<platformTab @change="handleClick" :showAll="false" :platformId="platformId" />

				<Tip :type="'warning'" class="tips-content" :showCloseIcon="true" v-if="isTrialAccount">
					<div class="ml-6 font-h6-regular cursor-pointer yx-color-text-primary" slot="content">
						您的账号为超佣团试用账号，试用账号每日不自动更新商品信息，如有商品信息变动需手动点击【同步商品】按钮
					</div>
				</Tip>
				<search
					:followUpState="followUpState"
					v-show="showPlatformContent"
					@clearImminent="clearImminent"
					ref="search"
					:key="platformId"
					@onSubmit="onSubmit"
					@clear="onClear"
					:platformId="platformId"
					isGoodsCat
				></search>
				<!--只有抖音有 商品流转记录---->
				<div class="flex flex-align-center location-public" v-if="$isPlatOr(['Dy', 'Ks']) && $auth.hasPermi('system:goods:flowRecord')">
					<span class="ml-8 fz-14 transfer-record yx-color-primary" @click="showGoodsRecord()">商品流转记录</span>
					<span class="red-dot ml-4" v-if="showTips"></span>
				</div>
			</div>
		</Panel>
		<Panel :contentPaddingTop="12" v-show="showPlatformContent">
			<div v-loading="loading">
				<div class="flex flex-just-between flex-align-center pl-16 pr-16 pt-18 pb-18">
					<div class="flex-row flex-align-center">
						<span class="mr-12 fz-14">
							已选
							<span class="yx-color-primary">{{ selectionShopArr.length }}</span>
						</span>
						<el-button v-if="(isShopPartnerDataView || isAllDataView) && $auth.hasPermi('system:goods:batch-examine')" @click="batchEvent('pass')">
							通过
						</el-button>
						<el-button
							v-if="$isPlatOr(['Dy', 'Ks']) && (isShopPartnerDataView || isAllDataView) && $auth.hasPermi('system:goods:batch-examine')"
							@click="batchEvent('rejecte')"
						>
							拒绝
						</el-button>
						<el-button v-if="$auth.hasPermi('system:goods-batch-allocation')" @click="batchFun(0)">分配</el-button>
						<el-button v-if="$auth.hasPermi('system:goods-batch-claim')" @click="batchFun(1)">认领</el-button>
						<div v-if="$auth.hasPermi('shopManage:export-good-shopManage')" class="ml-10">
							<export-list
								ref="exportList"
								:routerPath="routerPath"
								:platformId="platformId"
								:exportInterface="exportInterface"
								:exportDialog="exportDialog"
								:isExportImg="true"
							></export-list>
						</div>
						<button-group v-if="$auth.hasPermi('system:goods-synchronous')">
							<dy-goods-async-button
								v-if="$isPlatOr(platformId, ['Dy', 'Sp'])"
								ref="goodsAsyncBtn"
								needAuth
								:platformId="platformId"
								@refresh="getShopList"
							></dy-goods-async-button>
							<goods-async-button
								v-else
								ref="goodsAsyncBtn"
								needAuth
								:platformId="platformId"
								:sync_info="sync_info"
								type="multiTask"
								@refresh="getShopList"
							></goods-async-button>
						</button-group>
						<div class="mr-12">
							<el-checkbox v-model="params.is_claim" true-label="2" false-label="0" @change="onlyFun">未认领商品</el-checkbox>
						</div>
						<div class="mr-12">
							<el-checkbox v-model="checkedImminent" @change="onlyFunImminent">{{ $isSp(platformId) ? '临期商品' : '临期活动商品' }}</el-checkbox>
							<el-tooltip content="7天内活动将到期，请及时延长推广时间避免产生资损" placement="top-end">
								<i style="color: #86909d; font-size: 12px; margin-left: 4px" class="el-icon-question"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="flex flex-align-center flex-just-between"></div>
				</div>
				<multi-table
					class="multiTable"
					:ref="`multiTable`"
					:selectionChange="selectionChange"
					:columns="filterColumns"
					@gePartnerList="gePartnerList"
					:list="list"
					@getSortList="sortChange"
					:page="pageInfo"
					:options="options"
					:total="total"
				>
					<empty :isSearch="isSearch" slot="empty" :platformId="platformId" @btnClick="synchroFun"></empty>
				</multi-table>
			</div>
		</Panel>
		<claim @refreshList="getShopList" ref="claim" :platformId="platformId"></claim>
		<auditPass @refreshList="getShopList" ref="auditPass"></auditPass>
		<auditReject @refreshList="getShopList" ref="auditReject"></auditReject>
		<distribution :platformId="platformId" @refreshList="getShopList" ref="distribution" :selectionShopArr="selectionShopArr"></distribution>
		<anew-allocation-dialog :platformId="platformId" ref="anewAllocationDialog" @refreshList="getShopList" />

		<!--商品流转记录-->
		<flowGoodsDrawer ref="flowGoodsDrawer" @refresh="flowRecordNew" :platformId="platformId"></flowGoodsDrawer>
	</div>
</template>
<script>
import exportList from '@/views/common/exportList';
import { ksColumns, dyColumns, spColumns } from './columns';
import search from './components/search.vue';
import claim from './components/claim.vue';
import auditPass from './components/auditPass.vue';
import auditReject from './components/auditReject.vue';
import distribution from './components/distribution.vue';
import { claimList, cancelReceive, productInfoExport, getProductClaimLogRecord } from '@/api/shopManage';
import Empty from '@/views/shopManage/components/goodsEmpty.vue';
import { mapGetters } from 'vuex';
import { ksAuditStatusType, zsRoleType } from '@/utils/dataMap';
import anewAllocationDialog from '../../shopLibrary/list/components/anewAllocationDialog';
import GoodsAsyncButton from '@/modules/async/goods';
import dyGoodsAsyncButton from '@/modules/dyAsync/goods';
import { platformMixin } from '@rd/rd-ui';
import ButtonGroup from '@/components/ui/buttonGroup';
import debounce from 'lodash/debounce';
import flowGoodsDrawer from '@/components/business/flowGoodsDrawer/flowGoodsDrawer.vue';
import { getProductConfig } from '@/api/settings.js';
export default {
	name: 'TobeClaimedList',
	components: {
		search,
		claim,
		distribution,
		Empty,
		auditPass,
		auditReject,
		anewAllocationDialog,
		exportList,
		GoodsAsyncButton,
		dyGoodsAsyncButton,
		ButtonGroup,
		flowGoodsDrawer,
	},
	mixins: [platformMixin],
	computed: {
		...mapGetters(['defaultPlatform', 'isShopPartnerDataView', 'isAllDataView', 'isTrialAccount']),
		selectAllDisabled() {
			return !this.list.length;
		},
		filterArr() {
			return this.list.filter(({ audit_status }) => this.$isDy(this.platformId) || audit_status !== ksAuditStatusType.toBeReviewed);
		},
		columns() {
			const obj = {
				1: dyColumns,
				2: ksColumns,
				3: spColumns,
			};
			return obj[+this.platformId];
		},
		zsName() {
			return zsRoleType.name;
		},
		filterColumns() {
			let { columns } = this;
			let newArr = columns.filter(item => item.isShow);
			return newArr;
		},
	},
	data() {
		return {
			list: [],
			options: {
				selectable: true,
				border: false,
			},
			platformId: '',
			total: 0,
			allChecked: false,
			selectionShopArr: [],
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			params: {
				is_claim: '0',
			},
			isSearch: false,
			ksAuditStatusType,
			checkedImminent: false,
			loading: false,
			routerPath: '/shopManage/shopLibrary/record',
			ids: [],
			sync_info: null,
			DyStatus: new Map([
				['待审核', '1'],
				['审核通过', '2'],
				['审核拒绝', '3'],
				['建议二次报名', '5'],
				['未合作取消', '5'],
				['合作中取消', '5'],
				['', '5'],
				['1', '待审核'],
				['2', '审核通过'],
				['3', '审核拒绝'],
				['5', '已失效'],
			]), //抖音映射状态
			showTips: false, //是否有新的流转记录标识 抖音平台
			followUpState: 0, // 是否开启其他招商正在推广商品的店铺内所有商品
			fetchFollowUpState: false, // 是否加载了followUpState 数据
		};
	},
	created() {
		this.$isPlatOr(['Dy', 'Ks']) && this.getProductDuplicate();
	},
	methods: {
		handleClick(val) {
			this.platformId = val;
			if (this.$isPlatOr(['Dy', 'Ks'])) {
				this.getProductDuplicate();
			}
			if (!this.showPlatformContent) return;
			this.allChecked = false;
			this.params = {
				page_index: 1,
				page_size: 10,
				is_claim: '0',
			};
			this.checkedImminent = false;
		},
		//商品列表
		getShopList: debounce(async function (isSearch = false) {
			this.isSearch = isSearch;
			this.params.platform_id = this.platformId;
			this.loading = true;
			this.params.page_index = this.pageInfo.page_index;
			this.params.page_size = this.pageInfo.page_size;
			try {
				const { list = [], page, sync_info } = await claimList(this.params);
				if (this.$isDy(this.platformId)) {
					list.forEach(val => {
						val.audit_status = this.DyStatus.get(val.audit_status_desc);
						val.audit_status_desc = this.DyStatus.get(val.audit_status);
					});
				}
				this.list = list.map(item => ({
					...item,
					operations: this.getButtons(item),
				}));
				this.total = page.item_total;
				this.allChecked = false;
				this.selectionShopArr = [];
				this.loading = false;
				this.sync_info = sync_info;
				// 抖音平台 才调用是否有新的流转记录接口
				this.$isPlatOr(['Dy', 'Ks']) && this.flowRecordNew();
			} catch (error) {
				this.loading = false;
			}
		}, 300),
		//操作按钮
		getButtons(item) {
			const toBeReviewed = item.audit_status === ksAuditStatusType.toBeReviewed;
			const toBeReviewedSuccess = item.audit_status === ksAuditStatusType.Approved;
			const { isAllDataView, isShopPartnerDataView } = this;
			const pass = {
				label: '通过',
				type: 'text',
				classtype: 2,
				notSelf: item.forbidden_user_follow, // 这里的notSelf 是为了展示置灰的颜色，而不是不是自己的商品而禁选
				disabled: item.forbidden_user_follow,
				disabledTooltip: item.forbidden_user_follow,
				tooltipContent: `当前招商运营[${item.shop_claim_user_name}]正在跟进中，如需跟进请联系管理员分配`,
				show: toBeReviewed && (isShopPartnerDataView || isAllDataView) && this.$auth.hasPermi('system:goods:examine'),
				click: row => {
					const {
						outer_activity_id: third_activity_id,
						third_product_id: third_product_ids,
						platform_id,
						outer_activity_id,
						product_id,
						authority_id,
						shop_id,
					} = row;
					this.$refs.auditPass.show(
						[
							{
								third_activity_id,
								third_product_ids,
								audit_status: ksAuditStatusType.Approved,
								platform_id,
								outer_activity_id,
								product_id,
								authority_id,
								shop_id,
							},
						],
						'确认审核该商品，通过后将默认同时认领商品',
					);
				},
			};
			const rejecte = {
				label: '拒绝',
				type: 'text',
				classtype: 2,
				notSelf: item.forbidden_user_follow, // 这里的notSelf 是为了展示置灰的颜色，而不是不是自己的商品而禁选
				disabled: item.forbidden_user_follow,
				disabledTooltip: item.forbidden_user_follow,
				tooltipContent: `当前招商运营[${item.shop_claim_user_name}]正在跟进中，如需跟进请联系管理员分配`,
				show: this.$isPlatOr(['Dy', 'Ks']) && toBeReviewed && (isShopPartnerDataView || isAllDataView) && this.$auth.hasPermi('system:goods:examine'),
				click: row => {
					const {
						outer_activity_id: third_activity_id,
						third_product_id: third_product_ids,
						platform_id,
						outer_activity_id,
						product_id,
						authority_id,
						shop_id,
					} = row;
					this.$refs.auditReject.show(
						[
							{
								third_activity_id,
								third_product_ids,
								audit_status: ksAuditStatusType.rejected,
								platform_id,
								outer_activity_id,
								product_id,
								authority_id,
								shop_id,
							},
						],
						'拒绝后将不可恢复，确认要操作吗？',
					);
				},
			};
			const distribute = {
				label: '分配',
				type: 'text',
				classtype: 2,
				show: !item.partner_name && !toBeReviewed && !+item.account_id && this.$auth.hasPermi('system:goods:anew-goods'),
				click: row => this.$refs.distribution.disInit(row),
			};
			const againDistribute = {
				label: '重新分配',
				type: 'text',
				classtype: 2,
				show: item.partner_name && !toBeReviewed && +item.account_id && this.$auth.hasPermi('system:goods:anew-goods'),
				click: row => this.$refs.anewAllocationDialog.show(row),
			};
			const claim = {
				label: '认领',
				type: 'text',
				classtype: 2,
				notSelf: item.forbidden_user_follow, // 这里的notSelf 是为了展示置灰的颜色，而不是不是自己的商品而禁选
				disabled: item.forbidden_user_follow,
				disabledTooltip: item.forbidden_user_follow,
				tooltipContent: `当前招商运营[${item.shop_claim_user_name}]正在跟进中，如需跟进请联系管理员分配`,
				show: !item.partner_name && !toBeReviewed && !+item.account_id && this.$auth.hasPermi('system:goods:claim'),
				click: row => this.$refs.claim.initClaim(row, '确定要认领么？'),
			};
			const cancelClaim = {
				label: '取消认领',
				type: 'text',
				classtype: 2,
				show: (item.partner_name || !toBeReviewed) && +item.account_id && !!item.is_self && this.$auth.hasPermi('system:goods:claim'),
				click: this.cancelReceive,
			};
			const copyLink = {
				type: 'copyLink',
				show: toBeReviewedSuccess,
			};
			const viewDetail = {
				label: '查看详情',
				type: 'text',
				classtype: 2,
				show: this.$auth.hasPermi('system:goods-details-query'),
				click: row => {
					let handLink = this.$router.resolve({
						path: '/shopManage/tobeClaime/detail',
						query: {
							productId: row.product_id,
							thirdProductId: row.third_product_id,
							platformId: row.platform_id,
						},
					});
					window.open(handLink.href, '_blank');
				},
			};
			const arr = [pass, rejecte, distribute, againDistribute, copyLink, viewDetail, claim, cancelClaim];
			let newArr = arr.filter(item => item.show);
			return newArr;
		},
		//同步
		async synchroFun() {
			this.$refs.goodsAsyncBtn.click();
		},
		batchFun(type) {
			const { selectionShopArr } = this;
			//过滤掉待审核的商品
			let rows = selectionShopArr.filter(item => {
				return item.audit_status !== ksAuditStatusType.toBeReviewed;
			});
			if (!rows || rows.length === 0) {
				this.$message.warning('待审核商品需完成审核后才能分配招商运营');
				return;
			}
			!type ? this.$refs.distribution.disInit(rows) : this.$refs.claim.initClaim(rows);
		},
		batchEvent(type) {
			switch (type) {
				case 'pass':
					this.batchPass();
					break;
				case 'rejecte':
					this.batchRejecte();
					break;
			}
		},
		//批量通过
		batchPass() {
			let rows = this.selectionShopArr.filter(item => {
				return item.audit_status === ksAuditStatusType.toBeReviewed;
			});
			if (!rows || rows.length === 0) {
				this.$message.warning("仅处理'待审核'状态的商品");
				return;
			}
			this.$refs.auditPass.show(rows, `已选${rows.length}个待审核商品，通过后将默认同时认领商品`, true);
		},
		//批量拒绝
		batchRejecte() {
			let rows = this.selectionShopArr.filter(item => {
				return item.audit_status === ksAuditStatusType.toBeReviewed;
			});
			if (!rows || rows.length === 0) {
				this.$message.warning("仅处理'待审核'状态的商品");
				return;
			}
			this.$refs.auditReject.show(rows, `已选${rows.length}个待审核商品，拒绝后将不可恢复，确认要操作吗？`, true);
		},
		async cancelReceive({ is_cooperate, product_id }) {
			let title = '取消认领';
			let text = '取消认领后，商品将回到“团长商品”列表中，团队其他成员可以进行认领。';
			if (is_cooperate) {
				title = `无法${title}`;
				text = `由于该商品正在合作中，无法取消认领，请联系团队管理员重新分配${this.zsName}！`;
			}
			try {
				await this.$confirm(text, title);
				if (is_cooperate) return;
				const { code } = await cancelReceive({ product_id });
				if (code !== 0) return;
				this.$message.success('取消认领成功');
				this.getShopList();
			} catch (error) {}
		},
		//筛选
		onSubmit(val) {
			this.params = val;
			this.pageInfo.page_index = 1;
			this.pageInfo.page_size = 10;
			this.$refs['multiTable'].resetPage();
			this.getShopList(true);
		},
		//选择商品
		selectionChange(val) {
			this.selectionShopArr = val;
			this.ids = val.map(item => item.product_id);
		},
		onlyFun() {
			this.getShopList();
		},
		onlyFunImminent() {
			this.$refs['search'].imminentSelect(this.checkedImminent);
		},
		//选中值
		checkeFun(e) {
			this.allChecked = e;
			this.$refs['multiTable'].toggleSelection(this.filterArr, e);
		},
		gePartnerList({ page_index, page_size }) {
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.$backTop();
			this.getShopList();
		},
		// 排序方法
		sortChange({ order, prop }) {
			let orderBy = order ? (order === 'ascending' ? 'asc' : 'desc') : '';
			this.params.sort_desc = orderBy;
			this.params.sort = orderBy ? prop : '';
			this.pageInfo.page_index = 1;
			this.getShopList();
		},
		async exportInterface(that) {
			that.$refs.exportDialog.show(this.exportDialog);
		},
		async exportDialog(value) {
			const { platformId: platform_id, routerPath } = this;
			const { code } = await productInfoExport({ platform_id, type: 1, ...this.params, export_img: Number(value), ids: this.ids });
			if (code === 0) {
				const handLink = this.$router.resolve({
					path: routerPath,
					query: { platform_id },
				});
				window.open(handLink.href, '_blank');
			}
		},
		async flowRecordNew() {
			const data = await getProductClaimLogRecord({ platformId: this.platformId });
			this.showTips = data.showTips;
		},
		// 商品流转出现弹窗
		showGoodsRecord() {
			this.$refs.flowGoodsDrawer.show();
		},
		clearImminent() {
			this.checkedImminent = false;
		},
		// 搜索框清空
		onClear(val) {
			this.params = val;
			this.pageInfo.page_index = 1;
			this.pageInfo.page_size = 10;
			if (this.$refs.multiTable.$refs.baseTable.$refs.table) {
				this.$refs.multiTable.$refs.baseTable.$refs.table.clearSort();
			}
			this.$refs.multiTable.resetPage();
			this.checkedImminent = false;
			this.getShopList();
		},
		// 获取撞单规则
		async getProductDuplicate() {
			const { data, code } = await getProductConfig({ platformId: this.platformId });
			if (code === 0) {
				this.followUpState = data.productDuplicateAlone;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.mutil-table {
	/deep/ .el-table__header-wrapper {
		position: sticky;
		top: 1px;
		z-index: 1;
	}
}

.multiTable /deep/ .el-table th.audit-status.is-hidden {
	right: 100px !important;
}
.tips-content {
	position: relative;
	/deep/ .el-icon-info {
		top: 1px !important;
	}
	/deep/ .el-icon-close {
		top: 50% !important;
		transform: translateY(-50%);
		right: 20px !important;
	}
}
.location-public {
	position: absolute;
	right: 30px;
	top: 20px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	.transfer-record {
		position: relative;
		z-index: 111;
		cursor: pointer;
		color: #666;
	}
	.transfer-record:hover {
		color: @color-primary;
	}
}
</style>
